import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const PROJECT_FONT_SIZES = [
  'display-lg',
  'display-md',
  'display-sm',
  'headline-lg',
  'headline-md',
  'headline-sm',
  'title-lg',
  'title-md',
  'title-sm',
  'label-lg-prominent',
  'label-lg',
  'label-md-caps-prominent',
  'label-md',
  'label-sm',
  'body-lg',
  'body-md',
  'body-sm',
  'app-page-title',
  'app-card-title',
  'app-section-title',
  'app-subhead',
  'app-subhead-tight',
  'app-body',
  'app-body-medium',
  'app-dense',
  'app-dense-medium',
  'app-dense-tight',
  'app-dense-medium-tight',
  'app-meta',
  'app-meta-medium',
  'app-micro',
  'app-micro-tight',
  'app-mono',
  'app-mono-micro',
  'app-mono-micro-medium',
  'app-mono-micro-tight',
]

const twMerge = extendTailwindMerge({
  prefix: 'tw',
  extend: {
    theme: {
      text: PROJECT_FONT_SIZES,
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
